(function () {
  const root = document.querySelector('[data-pop-saved-portraits]');
  if (!root || root.dataset.initialized === 'true') return;
  const configElement = document.querySelector('[data-pop-saved-portraits-config]');
  let config = {};
  try { config = JSON.parse(configElement?.textContent || '{}'); } catch {}
  const avatars = root.querySelector('[data-pop-saved-portraits-avatars]');
  const count = root.querySelector('[data-pop-saved-portraits-count]');
  const openButton = root.querySelector('[data-pop-saved-portraits-open]');
  const dialog = root.querySelector('[data-pop-saved-portraits-dialog]');
  const closeButton = root.querySelector('[data-pop-saved-portraits-close]');
  const grid = root.querySelector('[data-pop-saved-portraits-grid]');
  const empty = root.querySelector('[data-pop-saved-portraits-empty]');
  if (!avatars || !count || !openButton || !dialog || !closeButton || !grid || !empty) return;
  root.dataset.initialized = 'true';

  const storageKeys = ['popPrints.savedPortraits.v1', 'popPrints.savedPortraits.shapes-preview.v1'];
  const productUrl = (value) => {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return '';
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch { return ''; }
  };
  const imageUrl = (value) => {
    const raw = typeof value === 'string' ? value.trim() : '';
    if (!raw) return '';
    if (/^data:image\/(?:png|jpe?g|webp|gif|avif);base64,[a-z0-9+/=\s]+$/i.test(raw)) return raw.length <= 200000 ? raw : '';
    try {
      const url = new URL(raw, window.location.origin);
      return !url.username && !url.password && (url.protocol === 'https:' ||
        (url.protocol === 'http:' && url.origin === window.location.origin)) ? url.toString() : '';
    } catch { return ''; }
  };
  const products = new Map((Array.isArray(config.products) ? config.products : [])
    .filter(product => product && product.id && productUrl(product.url))
    .map(product => [String(product.id), { url: productUrl(product.url), title: String(product.title || '') }]));
  const defaultUrl = productUrl(config.defaultProductUrl);

  const legacyProduct = (entry) => {
    if (entry.personalisation?.productId || entry.productId || entry.productUrl) return null;
    try {
      const artwork = new URL(String(entry.url || ''), window.location.origin);
      // Historical uploads carried their source product in this store's Shopify Files filename.
      const storeFile = (artwork.hostname === 'cdn.shopify.com' &&
        artwork.pathname.startsWith('/s/files/1/1007/3518/9338/files/')) ||
        (artwork.origin === window.location.origin && artwork.pathname.startsWith('/cdn/shop/files/'));
      if (!storeFile) return null;
      const filename = decodeURIComponent(artwork.pathname.split('/').pop() || '');
      const id = /^gemini_product-(\d+)_/.exec(filename)?.[1];
      return products.get(id) || null;
    } catch { return null; }
  };

  const readEntries = () => {
    const byArtwork = new Map();
    let sequence = 0;
    for (const key of storageKeys) {
      let entries;
      try { entries = JSON.parse(window.localStorage.getItem(key) || '[]'); } catch { continue; }
      if (!Array.isArray(entries)) continue;
      for (const entry of entries) {
        if (!entry || typeof entry !== 'object' || !imageUrl(entry.url)) continue;
        const artwork = imageUrl(entry.url);
        const previous = byArtwork.get(artwork);
        const merged = { ...previous, ...entry };
        for (const field of ['previewUrl', 'personalisation', 'productId', 'productUrl', 'productTitle', 'portraitShape', 'cacheId']) {
          if (!entry[field] && previous?.[field]) merged[field] = previous[field];
        }
        merged.displayUrl = imageUrl(merged.previewUrl) || artwork;
        merged.sequence = sequence++;
        byArtwork.set(artwork, merged);
      }
    }
    return [...byArtwork.values()].sort((a, b) =>
      ((Date.parse(b.createdAt) || 0) - (Date.parse(a.createdAt) || 0)) || b.sequence - a.sequence);
  };

  const portraitLink = (entry) => {
    const id = String(entry.personalisation?.productId || entry.productId || '');
    const product = products.get(id) || legacyProduct(entry);
    // Older generic portraits have no product binding. Identified styles must retain their own product.
    const target = product?.url || productUrl(entry.productUrl) || (!id && !entry.personalisation ? defaultUrl : '');
    const shape = entry.personalisation?.portraitShape || entry.portraitShape || 'portrait';
    if (!target || !['portrait', 'square', 'horizontal'].includes(shape)) return null;
    const url = new URL(target);
    const cacheId = String(entry.cacheId || '').trim();
    if (cacheId) url.searchParams.set('pp_saved', cacheId);
    if (!String(entry.url).startsWith('data:')) url.searchParams.set('pp_saved_url', String(entry.url).trim());
    else if (!cacheId) return null;
    url.searchParams.set('portrait_shape', shape);
    // Keep the explicitly selected preview while testing, without reviving an obsolete saved theme.
    const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme && /^\d+$/.test(previewTheme)) url.searchParams.set('preview_theme_id', previewTheme);
    return { url: url.toString(), title: product?.title || String(entry.productTitle || '') };
  };

  let savedPortraitCount = 0;
  const isCart = () => config.pageType === 'cart' || /\/cart\/?$/.test(window.location.pathname);
  const isExcluded = () => document.documentElement.hasAttribute('data-pop-portrait-restoring') ||
    Boolean(
    document.querySelector('main [data-testid="product-information"].personalisation-ready, main [data-personalisation-block].personalisation-complete')
  );
  const syncVisibility = () => {
    document.documentElement.classList.toggle('pop-has-multiple-saved-portraits', savedPortraitCount >= 2);
    root.hidden = savedPortraitCount < (isCart() ? 2 : 1) || isExcluded();
    if (root.hidden && dialog.open) dialog.close();
  };
  const makeImage = (entry) => {
    const image = new Image();
    image.src = entry.displayUrl;
    image.alt = '';
    image.referrerPolicy = 'no-referrer';
    image.decoding = 'async';
    return image;
  };
  const render = () => {
    if (!root.isConnected) return;
    const entries = readEntries();
    savedPortraitCount = entries.length;
    const links = entries.map(portraitLink);
    const allResumable = links.every(Boolean);
    count.textContent = entries.length
      ? `${entries.length} ${entries.length === 1 ? 'design' : 'designs'} ${allResumable ? 'ready to finish' : 'saved'}`
      : 'No saved portraits yet';
    avatars.replaceChildren(...entries.slice(0, 3).map(entry => {
      const image = makeImage(entry);
      image.className = 'pop-saved-portraits__avatar';
      return image;
    }));
    avatars.hidden = !entries.length;
    grid.replaceChildren(...entries.map((entry, index) => {
      const link = links[index];
      const card = document.createElement(link ? 'a' : 'div');
      card.className = 'pop-saved-portraits__card';
      if (link) card.href = link.url;
      const image = makeImage(entry);
      image.loading = 'lazy';
      const label = document.createElement('span');
      label.className = 'pop-saved-portraits__card-label';
      label.textContent = link?.title || String(entry.productTitle || `Saved portrait ${index + 1}`);
      card.append(image, label);
      if (link) card.setAttribute('aria-label', `Continue ${label.textContent}`);
      else {
        const unavailable = document.createElement('small');
        unavailable.textContent = 'This style is no longer available';
        card.append(unavailable);
      }
      return card;
    }));
    grid.hidden = !entries.length;
    empty.hidden = Boolean(entries.length);
    const createLink = empty.querySelector('a');
    if (createLink && defaultUrl) createLink.href = defaultUrl;
    syncVisibility();
  };

  openButton.addEventListener('click', () => {
    render();
    if (root.hidden) return;
    const entries = readEntries();
    const singleLink = entries.length === 1 ? portraitLink(entries[0]) : null;
    if (singleLink) {
      window.location.assign(singleLink.url);
      return;
    }
    dialog.showModal();
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('pop-saved-portraits-open');
  });
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('pop-saved-portraits-open');
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  document.addEventListener('pop:saved-portraits-change', render);
  window.addEventListener('storage', event => { if (event.key === null || storageKeys.includes(event.key)) render(); });
  window.addEventListener('pageshow', render);
  document.addEventListener('personalisation:art-ready', syncVisibility);
  document.addEventListener('pop:portrait-entry-ready', syncVisibility);
  const observeMain = () => {
    const main = document.querySelector('main');
    if (main) new MutationObserver(records => {
      if (records.some(record => record.type === 'childList' || record.target.matches?.('[data-testid="product-information"], [data-personalisation-block]'))) syncVisibility();
    }).observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    syncVisibility();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeMain, { once: true });
  else observeMain();

  // Follow the visible header edge so the strip remains visible as the page scrolls.
  const header = document.querySelector('header-component');
  let positionFrame = 0;
  let previousTop = -1;
  const position = () => {
    positionFrame = 0;
    const top = header && getComputedStyle(header).opacity !== '0' ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    if (top !== previousTop) {
      root.style.setProperty('--pop-saved-portraits-top', `${top}px`);
      previousTop = top;
    }
  };
  const schedulePosition = () => { if (!positionFrame) positionFrame = requestAnimationFrame(position); };
  window.addEventListener('scroll', schedulePosition, { passive: true });
  window.addEventListener('resize', schedulePosition);
  if (header && typeof ResizeObserver !== 'undefined') new ResizeObserver(schedulePosition).observe(header);
  position();
  render();
})();
